import { Button } from '@/components/ui/button';
import { StickyNote, X } from 'lucide-react';
import { toast } from 'sonner';

// Notes dialog (iter378) — quick add/edit of order notes from the
// touch-mode action toolbar. Persists to `notes` state which is
// submitted with the order.
export const PosNotesDialog = ({ open, notes, setNotes, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="pos-notes-overlay"
    >
      <div className="bg-white dark:bg-stone-900 rounded-2xl p-5 w-full max-w-md shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
              <StickyNote size={18} className="text-amber-700 dark:text-amber-300" />
            </div>
            <h3 className="font-bold text-base">Order Notes</h3>
          </div>
          <Button size="icon" variant="ghost" className="h-8 w-8 rounded-lg" onClick={onClose}><X size={16} /></Button>
        </div>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="e.g. No onions, extra spicy, ring bell on arrival..."
          className="w-full min-h-[120px] p-3 text-sm rounded-xl border border-border bg-white dark:bg-stone-800 focus:outline-none focus:ring-2 focus:ring-amber-300"
          data-testid="pos-notes-textarea"
        />
        <div className="flex justify-end gap-2 mt-3">
          <Button variant="outline" className="rounded-xl" onClick={() => setNotes('')}>Clear</Button>
          <Button
            className="bg-amber-500 hover:bg-amber-600 text-white rounded-xl"
            onClick={() => { onClose(); toast.success('Notes saved'); }}
            data-testid="pos-notes-save"
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PosNotesDialog;
